import type { EntryId } from "@schema/catalog.ts";
import { useProgressStore } from "@/state/progress.ts";
import styles from "./WatchToggle.module.css";

interface Props {
  entryId: EntryId;
  watched: boolean;
  title: string;
}

export function WatchToggle({ entryId, watched, title }: Props) {
  const toggleWatched = useProgressStore((s) => s.toggleWatched);
  return (
    <button
      type="button"
      className={`${styles.toggle} ${watched ? styles.on : ""}`}
      aria-pressed={watched}
      aria-label={`Mark ${title} as ${watched ? "unwatched" : "watched"}`}
      onClick={() => toggleWatched(entryId)}
    >
      <span aria-hidden="true">{watched ? "✓" : "○"}</span>
      {watched ? "Watched" : "Watch"}
    </button>
  );
}
